import { P2GBox } from '@parcel2go/core-ui';
import { MarketplaceOrderApiModel } from '~/lib/api/smartsend/types';
import P2GConditionalImage from '../../P2GConditionalImage';
import { P2GGrid } from '@parcel2go/core-ui';
import { GenerateSourceSquareUrlFromId } from '../../../lib/helpers/SourceUrlHelper';
import { P2GChip } from '@parcel2go/core-ui';
import { P2GText } from '@parcel2go/core-ui';
import { getMarketplaceOrderTransactionProcessedDate } from '../../../lib/helpers/SmartSendFilterApplier';
import { P2GDate } from '@parcel2go/core-ui';

interface props {
  item: MarketplaceOrderApiModel;
}

const MarketplaceItem: React.FC<props> = (props) => {
  return (
    <P2GBox>
      <P2GGrid container alignContent="center" alignItems="center" gap={2} wrap="nowrap">
        <P2GGrid item flexShrink={1}>
          <P2GBox bordered>
            <P2GConditionalImage
              style={{ width: '50px' }}
              src={props.item.Product.ImageUrl || GenerateSourceSquareUrlFromId(props.item.Source.Id)}
              alt="Logo"
            />
          </P2GBox>
        </P2GGrid>
        <P2GGrid item flexGrow={1}>
          <P2GBox>
            <P2GText>
              <strong>
                {props.item.Quantity} x {props.item.Product.Description}
              </strong>
            </P2GText>
          </P2GBox>
          <P2GBox mt={1}>
            <P2GGrid container spacing={1} alignItems="center" alignContent="center">
              {getMarketplaceOrderTransactionProcessedDate(props.item) && (
                <P2GGrid item>
                  <P2GDate size="small" date={getMarketplaceOrderTransactionProcessedDate(props.item)} />
                </P2GGrid>
              )}
              {props.item.CustomerReference && (
                <P2GGrid item>
                  <P2GChip size="small" label={props.item.CustomerReference} />
                </P2GGrid>
              )}
              {props.item.Product.Sku && (
                <P2GGrid item>
                  <P2GChip size="small" label={props.item.Product.Sku} />
                </P2GGrid>
              )}
            </P2GGrid>
          </P2GBox>
        </P2GGrid>
      </P2GGrid>
    </P2GBox>
  );
};
export default MarketplaceItem;
